define('drops/colorPicker/colorPicker',[
    'jquery',
    'lq/drop',
    'jquery.miniColors/jquery.miniColors',
    'lq/required',
    'lq/style'
], function ($, Drop, miniColors, Required, Style) {
    'use strict';

    var defaults = {
        data: {
            behaviour: 'popup',
            format: 'hex',
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            }
        }
    };

    function ColorPicker(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$colorPicker = this.createElement()
            .appendTo(this.$element)
            .minicolors('create', this.createData());
        this.value = null;

        Style.renderStyles(this);
    }

    Drop.extend(ColorPicker, Drop);

    ColorPicker.typeName = 'ColorPicker';

    ColorPicker.prototype.createElement = function () {
        return this.data.behaviour === 'popup'
            ? $('<input type="hidden" />')
            : $('<input type="text" />');
    };

    ColorPicker.prototype.createData = function () {
        var data = {
            change: this.colorChanged.bind(this)
        };

        if (this.data.behaviour === 'inline')
            data.inline = true;

        return data;
    };

    ColorPicker.prototype.colorChanged = function (value) {
        this.value = this.data.format === 'hex'
            ? value
            : this.$colorPicker.minicolors('rgbString');
        this.triggerEventIfEnabled('changed', this.value);
    };

    ColorPicker.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();
    };

    ColorPicker.prototype.postRender = function () {
        this.updatePosition();
        $('.licquid-action-wrapper').on('scroll',
            _.debounce(this.updatePosition.bind(this), 75)
        );
    };

    ColorPicker.prototype.clearValue = function () {
        this.value = '';
        this.$colorPicker
            .minicolors('value', { color: null, opacity: 1 });
    };

    ColorPicker.prototype.setValue = function (update) {
        this.value = update.value;
        this.$colorPicker
            .minicolors('value', { color: update.value, opacity: 1 });
    };

    ColorPicker.prototype.getValue = function () {
        return this.value;
    };

    ColorPicker.prototype.updatePosition = function () {
        if (!this.$colorPicker || this.data.behaviour === 'inline') return;

        const THRESHOLD = 175; // rough overestimate of minicolors popup size
        var newPosition = "";

        var parentPos = this.$colorPicker.closest('.drop-element').position();
        var offset = this.$colorPicker.closest('.drop-element').offset();

        var offsetTop = offset.top - $(window).scrollTop();
        var offsetLeft = offset.left - $(window).scrollLeft();
        
        if (parentPos.top + THRESHOLD > this.rootDrop.$element.height()
            || offsetTop + THRESHOLD > $(window).height())
            newPosition = "top";
        else newPosition = "bottom";

        if (parentPos.left + THRESHOLD > this.rootDrop.$element.width()
            || offsetLeft + THRESHOLD > $(window).width())
            newPosition += " right";
        else newPosition += " left";

        var currentPosition = this.$colorPicker.data('minicolors-settings').position;
        if (currentPosition != newPosition) {
            this.$colorPicker.minicolors('settings', { position: newPosition });
        }
    };

    return ColorPicker;
});
